import useUpdateExamination from './useUpdateExamination';

export default useUpdateExamination;
